/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to override the icon of the widget. If an iconOverride is provided, its value is what is applied
 * to the DOM instead of the icon. If the iconOverride is "" then the icon is what is applied to the DOM.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This works in conjunction with the IconMixin. DO mix this in after the IconMixin.
 *
 * @module MW/toolstrip/mixins/property/IconOverrideMixin
 *
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "mw-form/mixins/property/IconMixin"
], function (declare, IconMixin) {

    var IconOverrideMixin = declare(null, {

        /**
         * @property  {string} iconOverride  Supported Values: data-uri / CSS class
         * @instance
         */
        iconOverride: "",
        iconProp: "icon",

        postCreate: function () {
            this.inherited(arguments);

            // Since icon's default value is falsy, it will not trigger the setter during the widget construction phase
            // when attributes are being applied we need to call the setter explicitly.
            this.set("iconOverride", this.get("iconOverride"));
        },

        _setIconOverrideAttr: function (iconOverride) {
            if (typeof iconOverride !== "string") {
                throw new Error("'iconOverride' property expects a literal string!");
            }

            this._removeOldIcon(this.get("iconOverride"));
            this._set("iconOverride", iconOverride);
            this._updateDOM();
        },

        _setIconPropAttr: function(value){
            this._set("iconProp", value);
            this._updateDOM();
        }

    });

    IconOverrideMixin._dependencies = [
        {mixin: IconMixin, orderDependent: true}
    ];

    return IconOverrideMixin;

});
